<div mat-dialog-title class="dialog-title">
  <strong>Respuestas de la remesa</strong>
  <span>{{ data.completed_count }}/{{ data.total_count }} completadas</span>
</div>

<mat-dialog-content>
  @for (user of data.users; track user.id) {
    <div class="survey-wave-progress-user">
      @if (user.profile_picture_url) {
        <img class="survey-wave-progress-avatar" [src]="user.profile_picture_url" [alt]="user.full_name" />
      } @else {
        <span class="survey-wave-progress-avatar survey-wave-progress-avatar--placeholder">{{ user.full_name.charAt(0) }}</span>
      }
      <div class="survey-wave-progress-user-info">
        <span class="survey-wave-progress-user-name">{{ user.full_name }}</span>
        <span class="survey-wave-progress-user-meta">{{ user.questions_label }}</span>
      </div>
      <span class="status-badge" [attr.data-status]="user.status">{{ user.status_label }}</span>
    </div>
  } @empty {
    <div class="survey-wave-progress-empty">No hay usuarios asignados.</div>
  }
</mat-dialog-content>
